import React from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {
    formatCompositionModuleSizeParts,
    isCompositionModuleSizeBlocked,
} from "./compositionModuleScene";

const MODULE_SIZE_BLOCKED_TOOLTIP = "Размер менять нельзя";
const EDIT_WIDTH_TOOLTIP = "Нажмите, чтобы изменить ширину";

export default function Composition3DModuleSizeCell({
    row,
    disabled = false,
    faded = false,
    useCustomerModuleWidthLockRules = false,
    onWidthClick,
}) {
    const blocked = isCompositionModuleSizeBlocked(row, {
        customerRules: useCustomerModuleWidthLockRules,
    });
    const canEdit = !disabled && !blocked && typeof onWidthClick === "function";
    const {width, height, depth} = formatCompositionModuleSizeParts(row);
    const tooltip = blocked
        ? MODULE_SIZE_BLOCKED_TOOLTIP
        : (canEdit ? EDIT_WIDTH_TOOLTIP : undefined);

    return (
        <Tooltip title={tooltip ?? ""} arrow placement="top" disableHoverListener={!tooltip}>
            <Box
                component="span"
                sx={{
                    display: "inline",
                    opacity: faded ? 0.5 : 1,
                    fontSize: "inherit",
                    lineHeight: "inherit",
                }}
            >
                <Box
                    component="span"
                    onClick={(event) => {
                        event.stopPropagation();
                        if (canEdit) {
                            onWidthClick(row);
                        }
                    }}
                    sx={(theme) => ({
                        color: blocked
                            ? theme.palette.text.disabled
                            : (canEdit ? theme.palette.primary.main : theme.palette.text.primary),
                        fontWeight: canEdit ? 600 : 400,
                        cursor: canEdit ? "pointer" : "default",
                        borderRadius: "4px",
                        px: canEdit ? "4px" : 0,
                        mx: canEdit ? "-4px" : 0,
                        transition: theme.transitions.create(
                            ["background-color"],
                            {duration: theme.transitions.duration.shortest},
                        ),
                        ...(canEdit && {
                            "&:hover": {
                                backgroundColor: theme.palette.action.hover,
                            },
                            "&:focus-visible": {
                                outline: `2px solid ${theme.palette.primary.main}`,
                                outlineOffset: 1,
                            },
                        }),
                    })}
                    tabIndex={canEdit ? 0 : undefined}
                    role={canEdit ? "button" : undefined}
                    onKeyDown={(event) => {
                        if (!canEdit) return;
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            event.stopPropagation();
                            onWidthClick(row);
                        }
                    }}
                >
                    {width}
                </Box>
                {" × "}
                {height}
                {" × "}
                {depth}
            </Box>
        </Tooltip>
    );
}
